/**
 * 
 * @param {callback} fn 
 * @param {number} threshold 
 * @returns void
 */
 export function debounce( fn, threshold ) {

    var timeout;
    threshold = threshold || 100;

    return function debounced() {
      clearTimeout( timeout );
      var args = arguments;
      var _this = this;
      
      function delayed() {
        fn.apply( _this, args );
      }
      timeout = setTimeout( delayed, threshold );
    };
}